import {ArrangeButtons, CommentOverview, ExtEditButton, ExtViewButton} from '@dv5/components'
import {AppMode, DocumentPart, ItemAction, PositionChangeProps} from '@dv5/domain'
import {ButtonAction} from '@dv5/components'
import React, {FC} from "react"

interface Props {
    editMode: boolean
    mode: AppMode
    part: DocumentPart
    documentId: string
    arrangeProps: PositionChangeProps
    onSwap: (index: number, down: boolean) => void
    onMenuAction: (action: ItemAction) => void
    editMenuItems: Array<ButtonAction>
    showComments?: boolean
    showArrange?: boolean
    viewMenuItems: Array<ButtonAction>
}

export const DocumentPartActions: FC<Props> = ({
                                                   editMode,
                                                   showComments = true,
                                                   showArrange = true,
                                                   mode,
                                                   part,
                                                   documentId,
                                                   arrangeProps,
                                                   onSwap,
                                                   onMenuAction,
                                                   editMenuItems,
                                                   viewMenuItems,
                                               }) => {
    return (
        <div className={'actions ' + mode.toLowerCase()}>
            {!editMode && mode === AppMode.VIEW &&
                <ExtEditButton actions={viewMenuItems} onEdit={onMenuAction}/>}
            {showComments && !editMode && mode === AppMode.VIEW &&
                <CommentOverview
                    documentId={documentId}
                    sourceItemId={part.id}
                    commentsCount={part.commentsCount}
                    getCommentsMsg="documents.get-part-comments"
                    addCommentMsg="documents.add-comment"
                    editCommentMsg="documents.edit-part-comment"
                    deleteCommentMsg="documents.remove-part-comment"
                />}
            {editMode && mode === AppMode.VIEW &&
                <ExtViewButton actions={editMenuItems} onView={onMenuAction}/>}
            {showArrange && <ArrangeButtons arrangeProps={arrangeProps} onSwap={onSwap}/>}
        </div>
    )
}
